// third-party
import { FormattedMessage } from "react-intl";

// assets

import {
  IconUserCheck,
  IconLanguage,
  IconMessageLanguage,
  IconBuildingHospital,
  IconBuildingCommunity,
  IconUsers,
  IconUserCircle,
  IconBellRinging,
  IconBuildingSkyscraper,
  IconClipboardList,
  IconDeviceAnalytics,
  IconMessages,
  IconMail,
  IconHelp,
  IconHome,
} from "@tabler/icons";

// ==============================|| SAMPLE PAGE & DOCUMENTATION MENU ITEMS ||============================== //

const staff = {
  id: "sample-docs-roadmap",
  type: "group",
  role: "Staff",
  children: [
    {
      id: "Users",
      title: <FormattedMessage id="Users" />,
      type: "item",
      url: "/users",
      icon: IconUserCheck,
      breadcrumbs: false,
    },
    {
      id:  "Property Owner",
      title: <FormattedMessage id="Property Owner" />,
      type: "item",
      url: "/property-owner",
      icon: IconUserCircle,
      breadcrumbs: false,
    },
    {
      id: "Property Request",
      title: <FormattedMessage id="Property Request" />,
      type: "item",
      url: "/property-request",
      icon: IconBuildingSkyscraper,
      breadcrumbs: false,
    },

    {
      id: "Analytics",
      title: <FormattedMessage id="Analytics" />,
      type: "item",
      url: "/analytics",
      icon: IconDeviceAnalytics,
      breadcrumbs: false,
    },
    {
      id: "Properties",
      title: <FormattedMessage id="Properties" />,
      type: "item",
      url: "/properties",
      icon: IconHome,
      breadcrumbs: false,
    },

    {
      id: "Reported Properties",
      title: <FormattedMessage id="Reported Properties" />,
      type: "item",
      url: "/reported-properties",
      icon: IconBuildingCommunity,
      breadcrumbs: false,
    },
    {
      id: "Notification",
      title: <FormattedMessage id="Notification" />,
      type: "item",
      url: "/notification",
      icon: IconBellRinging,
      breadcrumbs: false,
      chip: {
        label: "9",
        color: "primary",
      },
    },
    {
      id: "Chat",
      title: <FormattedMessage id="Chat" />,
      type: "item",
      url: "/chat",
      icon: IconMessages,
      breadcrumbs: false,
      chip: {
        label: "3",
        color: "primary",
      },
    },
    {
      id: "Staff Support",
      title: <FormattedMessage id="Staff Support" />,
      type: "item",
      url: "/staff-support",
      icon: IconHelp,
      breadcrumbs: false,
    },
    {
      id: "Email Template",
      title: <FormattedMessage id="Email Template" />,
      type: "item",
      url: "/email-template",
      icon: IconMail,
      breadcrumbs: false,
    },
  ],
};

export default staff;
